import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';

export type CalculonChatFabSuppressionContextValue = {
    suppress: boolean;
    setSuppress: (value: boolean) => void;
};

const CalculonChatFabSuppressionContext = createContext<CalculonChatFabSuppressionContextValue | null>(null);

export const CalculonChatFabSuppressionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [suppress, setSuppress] = useState(false);
    const value = useMemo(() => ({ suppress, setSuppress }), [suppress]);
    return (
        <CalculonChatFabSuppressionContext.Provider value={value}>{children}</CalculonChatFabSuppressionContext.Provider>
    );
};

export function useCalculonChatFabSuppression(): CalculonChatFabSuppressionContextValue {
    const ctx = useContext(CalculonChatFabSuppressionContext);
    if (!ctx) {
        return { suppress: false, setSuppress: () => {} };
    }
    return ctx;
}
